import React from 'react'
import {
  Link,
  Navigate,
  useLocation,
  useOutlet,
  useParams,
  useRoutes
} from 'react-router-dom'
import { shallowEqual, useSelector } from 'react-redux'
import {
  getRole,
  canAccessLocation,
  canAccessLocationOfRoles,
  canViewLocationFinance,
  canAccessSpaceAPP,
  canAccessSpaceTaskFeedback,
  canViewSpaceFinance,
  canAccessSpaceStatistic,
  canAccessSpaceEnterprise,
  canAccessSpaceHr,
  canAccessSpaceFaq,
  canAdminLocation,
  canAdminSpace,
  canAccessSpaceFinance,
  canAccessLocationRoles,
  canAccessSpaceCRM,
  canAccessSpaceRepair,
  canAdminLocationActivity,
  canAdminLocationGroup,
  canAdminLocationGroups,
  canAccessLocationGroupAsManager,
  onlyCanAdminLocationOfWeChat,
  canAdminAccount,
  isGroupContentManager
} from 'app/reducers/role'

import HomePage from './containers/HomePage'
import Register from './containers/assist/Register'
import Login from './containers/assist/Login'
import LoginOld from './containers/assist/LoginOld'
import Unauthorized from './containers/assist/Unauthorized'
import Authorized from './containers/assist/Authorized'
import VerifyState from './containers/assist/VerifyState'
import ValidateEmail from './containers/assist/ValidateEmail'
import SendResetPassword from './containers/assist/SendResetPassword'
import ResetPassword from './containers/assist/ResetPassword'
import ResetPasswordSuccess from './containers/assist/ResetPasswordSuccess'
import SendUnlockEmail from './containers/assist/SendUnlockEmail'
import UnlockUser from './containers/assist/UnlockUser'

import CreateSpacePage from './containers/spaces/Create'
import CreateSpaceSuccess from './containers/spaces/CreateSpaceSuccess'
import AdminBox from './containers/shuck/AdminBox'
import AssistBox from './containers/shuck/AssistBox'
import LocationBox from './containers/shuck/LocationBox'
import PermissionBox from './containers/shuck/PermissionBox'

import CrmBox from 'containers/shuck/CrmBox'
import CrmIndex from 'containers/crm/CrmIndex'
import CrmOpportunity from 'containers/crm/CrmOpportunity'
import CrmWinSubscriptions from 'containers/crm/CrmWinSubscriptions'
import CrmOpportunityList from 'containers/crm/CrmOpportunityList'
import CrmNewOpportunityForm from 'containers/crm/CrmNewOpportunityForm'
import CrmLeads from 'containers/crm/CrmLeads'
import CrmInventory from 'containers/crm/CrmInventory'

import Members from 'containers/spaces/Members'

import TasksList from 'containers/tasks/TasksList'
import TasksListMe from 'containers/tasks/TasksListMe'
import TasksListAll from 'containers/tasks/TasksListAll'
import TasksListFollowing from 'containers/tasks/TasksListFollowing'
import TasksListReports from 'containers/tasks/TasksListReports'
import TaskInfo from 'containers/tasks/TaskInfo'
import TasksBox from 'containers/shuck/TasksBox'
import TaskBox from 'containers/shuck/TaskBox'

import FaqBox from 'containers/shuck/FaqBox'
import FaqDownload from 'containers/faq/FaqDownload'
import FaqMessage from 'containers/faq/FaqMessage'
import FaqTopicsForm from 'containers/faq/FaqTopicsForm'
import MessagesManage from 'containers/faq/MessagesManage'
import LocationsShow from 'containers/faq/LocationsShow'
import LocationSetting from 'containers/faq/LocationSetting'

import Announcements from 'containers/announcements/Announcements'

import ServiceBox from 'containers/shuck/ServiceBox'
import ServiceIndex from 'containers/service/ServiceIndex'
import ServiceProvider from 'containers/service/ServiceProvider'
import ProviderRequest from 'containers/service/ProviderRequest'
import ProviderDetail from 'containers/service/ProviderDetail'
import ServiceRequestDetail from 'containers/service/ServiceRequestDetail'
import ServiceRequest from 'containers/service/ServiceRequest'

import LockBox from 'containers/shuck/LockBox'
import LockManageBox from 'containers/shuck/LockManageBox'
import LockIndex from 'containers/locks/LockIndex'
import LockEvents from 'containers/locks/LockEvents'
import LockInfo from 'containers/locks/LockInfo'
import LockPermissions from 'containers/locks/LockPermissions'
import LockDashboard from 'containers/locks/LockDashboard'
import ItemLockDashboard from 'containers/locks/ItemLockDashboard'
import LockEntryRecord from 'containers/locks/LockEntryRecord'
import LockInactiveUsers from 'containers/locks/LockInactiveUsers'
import LockGroups from 'containers/locks/LockGroups'
import LockGroupDetail from 'containers/locks/LockGroupDetail'

import MeetingIndex from 'containers/meeting/MeetingIndex'
import MeetingBox from 'containers/shuck/MeetingBox'
import MeetingRecord from 'containers/meeting/MeetingRecord'
import MeetingManage from 'containers/meeting/MeetingManage'
import MeetingAddBooking from 'containers/meeting/MeetingAddBooking'
import MeetingInfo from 'containers/meeting/MeetingInfo'
import MeetingTheme from 'containers/meeting/MeetingTheme'
import MeetingDeviceDetail from 'containers/meeting/MeetingDeviceDetail'
import MeetingCoupon from 'containers/meeting/MeetingCoupon'
import CouponDetail from 'containers/meeting/CouponDetail'

import ApplicationBox from 'containers/shuck/ApplicationBox'
import Applications from 'containers/application/Applications'
import ItemApplications from 'containers/application/ItemApplications'

import ValueAddedServicesList from 'containers/valueAddedServices/ValueAddedServicesList'
import ValueAddedIntention from 'containers/valueAddedServices/ValueAddedIntention'
import EditValueAddedServices from 'containers/valueAddedServices/EditValueAddedServices'
import EditPlayBook from 'containers/valueAddedServices/EditPlayBook'

import MemberWelfareList from 'containers/memberWelfare/MemberWelfareList'
import MemberWelfareInfo from 'containers/memberWelfare/MemberWelfareInfo'

import SpaceStatisticBox from 'containers/shuck/SpaceStatisticBox'
import StatisticCrmBox from 'containers/statistic/StatisticCrmBox'
import StatisticTaskBox from 'containers/statistic/StatisticTaskBox'
import StatisticMeetingBox from 'containers/statistic/StatisticMeetingBox'
import StatisticDeskBox from 'containers/statistic/StatisticDeskBox'
import StatisticInvoiceBox from 'containers/statistic/StatisticInvoiceBox'
import StatisticOrgBox from 'containers/statistic/StatisticOrgBox'
import StatisticLockBox from 'containers/statistic/StatisticLockBox'

import SpaceLocationStatisticBox from 'containers/shuck/SpaceLocationStatisticBox'

import InvoicesBox from 'containers/invoices/InvoicesBox'
import InvoiceBox from 'containers/shuck/InvoiceBox'
import InvoicesContract from 'containers/invoices/InvoicesContract'
import Invoices from 'containers/invoices/Invoices'
import InvoicesApplicationList from 'containers/invoices/InvoicesApplicationList'
import InvoicingPoolList from 'containers/invoices/InvoicingPoolList'
import InvoicePayments from 'containers/invoices/InvoicePayments'
import InvoicesInfo from 'containers/invoices/InvoicesInfo'
import InvoiceSendEmail from 'containers/invoices/InvoiceSendEmail'
import StatisticInvoiceMonthly from 'containers/invoices/StatisticInvoiceMonthly'
import StatisticsInvoiceConfirmed from 'containers/invoices/StatisticsInvoiceConfirmed'
import DepositList from 'containers/invoices/DepositList'

import OrdersBox from 'containers/orders/OrdersBox'
import OrdersInfo from 'containers/orders/OrdersInfo'
import OrdersPersonal from 'containers/orders/OrdersPersonal'
import OrdersOrg from 'containers/orders/OrdersOrg'

import Locations from 'containers/spaces/Locations'
import Organization from 'containers/organization/Organization'
import EditOrganization from 'containers/organization/EditOrganization'
import OrganizationMembers from 'containers/organization/OrganizationMembers'
import OrgSummarize from 'containers/organization/OrgSummarize'
import OrgSubscriptions from 'containers/organization/OrgSubscriptions'
import OrgAccounting from 'containers/organization/OrgAccounting'
import OrganizationPoint from 'containers/organization/OrganizationPoint'
import OrganizationMeeting from 'containers/organization/OrganizationMeeting'
import OrganizationAnnex from 'containers/organization/OrganizationAnnex'

import Organizations from 'containers/organization/Organizations'
import CreateOrganization from 'containers/organization/createOrganization/CreateOrganization'
import NewOrgSubscription from 'containers/organization/NewOrgSubscription'
import SubscriptionDetailBox from 'containers/organization/SubscriptionDetailBox'
import OrgSubscriptionDetailHistories from 'containers/organization/OrgSubscriptionDetailHistories'
import OrgSubscriptionDetail from 'containers/organization/OrgSubscriptionDetail'
import OrgSubscriptionDetailHistory from 'containers/organization/OrgSubscriptionDetailHistory'
import OrgSubscriptionDetailInvoices from 'containers/organization/OrgSubscriptionDetailInvoices'
import LocationMemberInfo from 'containers/members/LocationMemberInfo'
import MembersMessage from 'containers/members/MembersMessage'
import MembersLocksRecord from 'containers/members/MembersLocksRecord'
import MembersLockPermission from 'containers/members/MembersLockPermission'
import MembersMeetRecord from 'containers/members/MembersMeetRecord'
import MembersPoint from 'containers/members/MembersPoint'
import MembersElevator from 'containers/members/MembersElevator'
import OrgDetailBox from 'containers/members/OrgDetailBox'
import OrgDetail from 'containers/members/OrgDetail'
import OrgMembers from 'containers/members/OrgMembers'
import LocationSettingBox from 'containers/shuck/LocationSettingBox'
import LocationSetBase from 'containers/spaces/LocationSetBase'
import LocationSetRole from 'containers/spaces/LocationSetRole'
import LocationSetInvoice from 'containers/spaces/LocationSetInvoice'
import LocationSetLock from 'containers/spaces/LocationSetLock'
import LocationSetArea from 'containers/spaces/LocationSetArea'
import LocationSetSubscription from 'containers/spaces/LocationSetSubscription'
import LocationSetMeeting from 'containers/spaces/LocationSetMeeting'
import GuideLocation from 'containers/spaces/GuideLocation'
import FloorManage from 'containers/spaces/FloorManage'
import LocationSetOpenFunc from 'containers/spaces/LocationSetOpenFunc'
import LocationSetPrinterManage from 'containers/spaces/LocationSetPrinterManage'
import LocationSetLockPermission from 'containers/spaces/LocationSetLockPermission'

import Visit from 'containers/visit/Visit'
import VisitBox from 'containers/visit/VisitBox'
import VisitDeviceManage from 'containers/visit/VisitDeviceManage'
import VisitBlackList from 'containers/visit/VisitBlackList'
import VisitDeviceAdd from 'containers/visit/VisitDeviceAdd'
import VisitSettingsBox from 'containers/visit/VisitSettingsBox'
import VisitWelcomeSet from 'containers/visit/VisitWelcomeSet'
import VisitSignInSet from 'containers/visit/VisitSignInSet'
import VisitTypeEditForm from 'containers/visit/VisitTypeEditForm'
import VisitNotifySet from 'containers/visit/VisitNotifySet'
import VisitSignOutSet from 'containers/visit/VisitSignOutSet'
import VisitSignProcedure from 'containers/visit/VisitSignProcedure'
import VisitAutomaticCheck from 'containers/visit/VisitAutomaticCheck'

import AreasList from 'containers/desks/Areas'
import AreaFloorPlan from 'containers/desks/AreaFloorPlan'
import AreasBox from 'containers/shuck/AreasBox'
import AreaBox from 'containers/shuck/AreaBox'
import AreasContainer from 'containers/desks/AreasContainer'
import AreasTimeLine from 'containers/desks/AreasTimeLine'
import Desks from 'containers/desks/Desks'
import DeskReservationList from 'containers/desks/DeskReservationList'
import LocationMembers from 'containers/members/LocationMembers'

import SpaceReportBox from 'containers/shuck/SpaceReportBox'
import ReportIndex from 'containers/report/ReportIndex'

import MembershipsBox from 'containers/memberships/MembershipsBox'
import MembershipsHome from 'containers/memberships/MembershipsHome'
import MembershipsManage from 'containers/memberships/MembershipsManage'
import MembershipsMembers from 'containers/memberships/MembershipsMembers'
import MembershipsNonMembers from 'containers/memberships/MembershipsNonMembers'
import MembershipsCards from 'containers/memberships/MembershipsCards'
import MembershipsResources from 'containers/memberships/MembershipsResources'
import MembershipsPointsRecord from 'containers/memberships/MembershipsPointsRecord'
import SpaceAddMemberShip from 'containers/memberships/SpaceAddMemberShip'
import SpaceAddMemberShipSource from 'containers/memberships/SpaceAddMemberShipSource'

import SpacesSettingBox from 'containers/shuck/SpacesSettingBox'
import SpacesSettingBase from 'containers/spaces/setting/SpacesSettingBase'
import SpacesSettingCrm from 'containers/spaces/setting/SpacesSettingCrm'
import SpacesSettingSafe from 'containers/spaces/setting/SpacesSettingSafe'
import SpaceSettingInvoice from 'containers/spaces/setting/SpaceSettingInvoice'
import SpaceEmailTemplete from 'containers/spaces/setting/SpaceEmailTemplete'
import SpaceSettingMeeting from 'containers/spaces/setting/SpaceSettingMeeting'
import SpaceSettingLockers from 'containers/spaces/setting/SpaceSettingLockers'
import SpaceSettingOptions from 'containers/spaces/setting/SpaceSettingOptions'
import SpaceSettingService from 'containers/spaces/setting/SpaceSettingService'
import SpacesSettingLocationGroups from 'containers/spaces/setting/SpacesSettingLocationGroups'
import SpaceSettingLock from 'containers/spaces/setting/SpaceSettingLock'
import SpaceSettingCurrency from 'containers/spaces/setting/SpaceSettingCurrency'
import SpacePayFlow from 'containers/spaces/setting/SpacePayFlow'
import SpaceSettingPay from 'containers/spaces/setting/SpaceSettingPay'

import SpaceMemberInfo from 'containers/members/SpaceMemberInfo'

import UserSettingBox from 'containers/shuck/UserSettingBox'
import UserInfo from 'containers/user/UserInfo'
import PassWord from 'containers/user/PassWord'

// 显示分店的首页
import LocationHomePage from 'containers/spaces/LocationHomePage'
// 显示分区的信息列表
import LocationAreas from 'containers/spaces/LocationAreas'
import LocationAreasUsage from 'containers/spaces/LocationAreasUsage'

// excel导入引导页面
import GuidePage from 'containers/spaces/GuidePage'

// 合同模板
import SpaceTempleteBox from 'containers/spaces/setting/templete/SpaceTempleteBox'
import SpaceTempleteEdit from 'containers/spaces/setting/templete/SpaceTempleteEdit'
import SpaceTempleteList from 'containers/spaces/setting/templete/SpaceTempleteList'

// 操作记录
import SpaceLogs from 'containers/spaces/setting/SpaceLogs'

// 商城
import ShoppingBox from 'containers/shopping/ShoppingBox'
import SalesProductsBox from 'containers/shopping/SalesProductsBox'
import Shops from 'containers/shopping/Shops'
import ProductCategories from 'containers/shopping/ProductCategories'
import ProductOrders from 'containers/shopping/ProductOrders'
import ProductOrderInfo from 'containers/shopping/ProductOrderInfo'
import SalesProducts from 'containers/shopping/SalesProducts'

// 活动
import ActivityBox from 'containers/activities/ActivityBox'
import ActivitiesList from 'containers/activities/ActivitiesList'
import ActivitiesInfo from 'containers/activities/ActivitiesInfo'
import ActivitiesContainer from 'containers/activities/ActivitiesContainer'
import ActivitiesOrders from 'containers/activities/ActivitiesOrders'
import ActivitiesCreateForm from 'containers/activities/ActivitiesCreateForm'
import ActivitiesComments from 'containers/activities/ActivitiesComments'

// 加购管理
import ReplacementBox from 'containers/replacement/ReplacementBox'
import ReplacementList from 'containers/replacement/ReplacementList'
import ReplacementInfo from 'containers/replacement/ReplacementInfo'
import ReplacementContainer from 'containers/replacement/ReplacementContainer'
import ReplacementOrders from 'containers/replacement/ReplacementOrders'
import ReplacementCreateForm from 'containers/replacement/ReplacementCreateForm'

// 储物柜
import LockersBox from 'containers/lockers/LockersBox'
import Lockers from 'containers/lockers/Lockers'
import LockerRecord from 'containers/lockers/LockerRecord'
import LockerCleanUpRecord from 'containers/lockers/LockerCleanUpRecord'
import LockerCategories from 'containers/lockers/LockerCategories'

// 灯控
import LightBox from 'containers/light/LightBox'
import Light from 'containers/light/Light'

// 资讯
import NewsBox from 'containers/news/NewsBox'
import NewsList from 'containers/news/NewsList'
import NewsDetail from 'containers/news/NewsDetail'
import NewsEditForm from 'containers/news/NewsEditForm'

// 社群帖子
import PostList from 'containers/posts/PostList'
import PostDetail from 'containers/posts/PostDetail'

// 车位
import ParkingBox from 'containers/parking/ParkingBox'
import ParkingManageBox from 'containers/parking/ParkingManageBox'
import ParkingList from 'containers/parking/ParkingList'
import ParkingTimeLine from 'containers/parking/ParkingTimeLine'
import ParkingContracts from 'containers/parking/ParkingContracts'
import ParkingContractCreate from 'containers/parking/ParkingContractCreate'
import ParkingReservation from 'containers/parking/ParkingReservation'
import ParkingContractPlatesRecord from 'containers/parking/ParkingContractPlatesRecord'

import AppBox from 'containers/shuck/AppBox'
import ValueAddedServicesBox from 'containers/shuck/ValueAddedServicesBox'

//项目
import Groups from 'containers/spaces/Groups'
import GroupBox from 'containers/shuck/GroupBox'
import GroupSettingBox from 'containers/shuck/GroupSettingBox'
import GroupSetBase from 'containers/spaces/GroupSetBase'
import GroupSetPayment from 'containers/spaces/GroupSetPayment'
import GroupSetVirtualMoney from 'containers/spaces/GroupSetVirtualMoney'
import GroupLockBox from 'containers/shuck/GroupLockBox'
import GroupSetRole from 'containers/spaces/GroupSetRole'
import GroupSetStation from 'containers/spaces/GroupSetStation'
import GroupSetBanner from 'containers/spaces/GroupSetBanner'
import GroupSetActivity from 'containers/spaces/GroupSetActivity'
import GroupSetPreview from 'containers/spaces/GroupSetPreview'
import GroupSetValueAddedServices from 'containers/spaces/GroupSetValueAddedServices'
// 自助认证
import SpaceAutoAuth from 'containers/shuck/SpaceAutoAuth'
import AuthList from 'containers/autoAuth/AuthList'
// 优惠券
import CouponBox from 'containers/shuck/CouponBox'
import CouponList from 'containers/coupon/CouponList'
import CouponContainer from 'containers/coupon/CouponContainer'
import CouponInfo from 'containers/coupon/CouponInfo'
import CouponForm from 'containers/coupon/CouponForm'
import CouponOrders from 'containers/coupon/CouponOrders'

// init scss
require('./styles/init.scss')

const LegacyRoutePropsContext = React.createContext({})

function LegacyRoutePropsBridge({ children, ...props }) {
  const parentProps = React.useContext(LegacyRoutePropsContext)
  const nextProps = {
    ...parentProps,
    ...props
  }
  return (
    <LegacyRoutePropsContext.Provider value={nextProps}>
      {children}
    </LegacyRoutePropsContext.Provider>
  )
}

class PageNotFound extends React.Component {
  render() {
    return (
      <div>
        <h1>Page Not Found.</h1>
        <p>
          Go to <Link to="/">Home Page</Link>
        </p>
      </div>
    )
  }
}

function getQuery(search) {
  return Object.fromEntries(new URLSearchParams(search))
}

function RouteElement({ component: Component, ...props }) {
  const parentProps = React.useContext(LegacyRoutePropsContext)
  const params = useParams()
  const location = useLocation()
  const outlet = useOutlet()
  const legacyLocation = {
    ...location,
    query: getQuery(location.search)
  }

  return (
    <Component
      {...parentProps}
      {...props}
      params={params}
      location={legacyLocation}>
      {outlet ?
        <LegacyRoutePropsBridge {...parentProps} {...props}>
          {outlet}
        </LegacyRoutePropsBridge> :
        null}
    </Component>
  )
}

function EmptyLayout({ children }) {
  return children || null
}

function route(path, component, children) {
  return {
    path,
    element: <RouteElement component={component} />,
    children
  }
}

function layout(component, children) {
  return {
    element: <RouteElement component={component} />,
    children
  }
}

function index(component) {
  return {
    index: true,
    element: <RouteElement component={component} />
  }
}

const subscriptionDetailRoutes = [
  index(OrgSubscriptionDetail),
  route('history', OrgSubscriptionDetailHistory),
  route('histories', OrgSubscriptionDetailHistories),
  route('invoices', OrgSubscriptionDetailInvoices),
  route('plates_record', ParkingContractPlatesRecord)
]

function createAuthWrapper({
  authSelector,
  failureRedirectPath = '/login',
  predicate
}) {
  return Component => {
    function AuthRoute(props) {
      const authData = useSelector(
        state => authSelector(state, props),
        shallowEqual
      )
      const passed = predicate
        ? predicate(authData)
        : authData && Object.keys(authData).length

      if (!passed) {
        return <Navigate to={failureRedirectPath} replace />
      }

      return <Component {...props} />
    }

    return AuthRoute
  }
}

// Redirects to /login by default
const UserIsAuthenticated = createAuthWrapper({
  authSelector: state => state.user
})

// Admin Authorization, redirects non-admins to /app and don't send a redirect param
const UserIsAdmin = createAuthWrapper({
  authSelector: state => state.user,
  failureRedirectPath: '/',
  predicate: user => canAdminSpace(user)||canAdminLocationActivity(user),
})

const UserCanAccessFinance = createAuthWrapper({
  authSelector: state => state.user,
  failureRedirectPath: '/',
  predicate: user => canViewSpaceFinance(user),
})

const UserCanAccessMemberships = createAuthWrapper({
  authSelector: state => state.user,
  failureRedirectPath: '/',
  predicate: user =>
    canAdminSpace(user) ||
    canAdminLocationActivity(user) ||
    canAdminLocationGroup(user),
})

const UserCanAccessLocationFinance = createAuthWrapper({
  authSelector: state => state.user,
  failureRedirectPath: '/',
  predicate: user => canViewLocationFinance(user),
})

const UserCanAccessRepair = createAuthWrapper({
  authSelector: state => state.user,
  failureRedirectPath: '/',
  predicate: user =>
    canAccessSpaceRepair(user) || canAccessSpaceTaskFeedback(user),
})

const UserCanAccessFaq = createAuthWrapper({
  authSelector: state => state.user,
  failureRedirectPath: '/',
  predicate: user => canAccessSpaceFaq(user),
})

const UserCanAccessAPP = createAuthWrapper({
  authSelector: state => state.user,
  failureRedirectPath: '/',
  predicate: user => canAccessSpaceAPP(user),
})

const UserCanAccessStatistic = createAuthWrapper({
  authSelector: state => state.user,
  failureRedirectPath: '/',
  predicate: user => canAccessSpaceStatistic(user),
})

const UserCanAccessEnterprise = createAuthWrapper({
  authSelector: state => state.user,
  failureRedirectPath: '/',
  predicate: user => canAccessSpaceEnterprise(user),
})

const UserCanAccessHr = createAuthWrapper({
  authSelector: state => state.user,
  failureRedirectPath: '/',
  predicate: user => canAccessSpaceHr(user) || canAdminAccount(user),
})

const UserCanAccessCRM = createAuthWrapper({
  authSelector: state => state.user,
  failureRedirectPath: '/',
  predicate: user => canAccessSpaceCRM(user),
})

function RootRedirect() {
  const user = useSelector(state => state.user, shallowEqual)

  if (!user || !user.id) {
    return <Navigate to="/login" replace />
  }

  return <HomePage />
}

// UserCanAccessLocation assumes :id in URL is location id
const UserCanAccessLocation = createAuthWrapper({
  authSelector: (state, ownProps) => {
    return ({
    user: state.user,
    location_id: ownProps.params.id,
    isGroup: ownProps.location.pathname.indexOf('/admin/groups') !== -1,
    pathname: ownProps.location.pathname
  })},
  // 分店id和项目id混淆了
  predicate: ({ user, location_id, isGroup, pathname }) =>
    canAccessLocationOfRoles(user, location_id) || (isGroup && canAccessLocationGroupAsManager(user, location_id)) || isGroupContentManager(user, location_id, isGroup, pathname) || canAdminLocationGroups(user,location_id) || onlyCanAdminLocationOfWeChat(user, location_id) || (canAccessSpaceFinance(user) || canAccessLocationRoles(user, location_id, ['invoice_check', 'invoice_confirm', 'invoice_check_notify'])) || canAccessLocationRoles(user, location_id, ['landlord']),
  failureRedirectPath: '/',
})

// UserCanAdminLocation assumes :id in URL is location id
const UserCanAdminLocation = createAuthWrapper({
  authSelector: (state, ownProps) => ({
    user: state.user,
    location_id: ownProps.params.id
  }),
  predicate: ({ user, location_id }) => canAdminLocation(user, location_id),
  failureRedirectPath: `/`,
})

const assistRoutes = [
  route('login', Login),
  process.env.NODE_ENV === 'development' ||
  process.env.REACT_APP_URLCONFIG === 'dev' ||
  process.env.REACT_APP_URLCONFIG === 'preprod' ||
  process.env.REACT_APP_URLCONFIG === 'uat'
    ? route('LoginOld', LoginOld)
    : null,
  route('unauthorized', Unauthorized),
  route('authorized', Authorized),
  route('register', Register),
  route('send_unlock_email', SendUnlockEmail),
  route('unlock_user', UnlockUser),
  route('send_reset_password', SendResetPassword),
  route('reset_password', ResetPassword),
  route('reset_password_success', ResetPasswordSuccess),
  route('verify_state', VerifyState),
  route('validate_email', ValidateEmail)
].filter(Boolean)

const appRoutes = [
  {
    path: '/',
    element: <RouteElement component={EmptyLayout} />,
    children: [
      index(RootRedirect),
      layout(AssistBox, assistRoutes),
      route('spaces', UserIsAuthenticated(AssistBox), [
        route('create', CreateSpacePage),
        route('create_success', CreateSpaceSuccess)
      ]),
      route('admin', UserIsAuthenticated(AdminBox), [
        index(Locations),
        route('groups/:id', UserCanAccessLocation(GroupBox), [
          index(Groups),
          route('app', UserCanAccessLocation(AppBox), [index(ItemApplications)]),
          route('valueAddedServices', UserCanAccessLocation(ValueAddedServicesBox), [
            index(ValueAddedServicesList),
            route('intention', ValueAddedIntention),
            route('edit', EditValueAddedServices),
            route('editPlaybook', EditPlayBook)
          ]),
          route('memberWelfare', EmptyLayout, [
            index(MemberWelfareList),
            route('edit', MemberWelfareInfo)
          ]),
          route('locks', UserCanAccessLocation(GroupLockBox), [index(ItemLockDashboard)]),
          route('statistic', UserCanAccessLocation(SpaceStatisticBox), [
            index(StatisticDeskBox),
            route('crm', StatisticCrmBox),
            route('task', StatisticTaskBox),
            route('meeting', StatisticMeetingBox),
            route('organization', StatisticOrgBox),
            route('invoice', StatisticInvoiceBox),
            route('lock', StatisticLockBox)
          ]),
          route('settings', GroupSettingBox, [
            index(GroupSetBase),
            route('meeting', SpaceSettingMeeting),
            route('payment', GroupSetPayment),
            route('virtualMoney', GroupSetVirtualMoney),
            route('lockers', SpaceSettingLockers),
            route('options', SpaceSettingOptions),
            route('role', GroupSetRole),
            route('station', GroupSetStation),
            route('banner', GroupSetBanner),
            route('finance', LocationSetInvoice),
            route('activity', GroupSetActivity),
            route('preview', GroupSetPreview),
            route('valueAddedServices', GroupSetValueAddedServices),
            route('invoice/editTemplate', SpaceTempleteEdit)
          ])
        ]),
        route('locations', UserCanAccessLocation(PermissionBox), [index(Locations)]),
        route('employee', UserCanAccessHr(PermissionBox), [index(Members)]),
        route('invoices', UserCanAccessFinance(InvoiceBox), [
          index(InvoicesContract),
          route('invoices_list', Invoices),
          route('invoices_application', InvoicesApplicationList),
          route('invoicing_pool', InvoicingPoolList),
          route('invoice_payments', InvoicePayments),
          route('invoices_list/:invoice_id', InvoicesInfo),
          route(':invoice_id/organizations/:organization_id/subscriptions/new', NewOrgSubscription),
          route(':invoice_id/organizations/:organization_id/subscriptions/:subscription_id', SubscriptionDetailBox, subscriptionDetailRoutes),
          route('membership_orders', OrdersPersonal),
          route('membership_orders/:invoice_id', OrdersInfo),
          route(':invoice_id/email', InvoiceSendEmail),
          route('monthly_invoices', StatisticInvoiceMonthly),
          route('confirmed_invoices', StatisticsInvoiceConfirmed),
          route('deposit', DepositList)
        ]),
        route('tasks', UserCanAccessRepair(TasksBox), [
          route('repair', TaskBox, [
            index(TasksList),
            route('type/my', TasksListMe),
            route('type/all', TasksListAll),
            route('type/following', TasksListFollowing),
            route('type/reports', TasksListReports),
            route(':task_id', TaskInfo)
          ]),
          route('custom_service', TasksList),
          route('custom_service/:task_id', TaskInfo),
          route('feedback', TasksList),
          route('feedback/:task_id', TaskInfo)
        ]),
        route('shopping', ShoppingBox, [
          index(Shops),
          route(':shopping_id', SalesProductsBox, [
            index(SalesProducts),
            route('product_categories', ProductCategories),
            route('product_orders', ProductOrders)
          ]),
          route(':shopping_id/product_orders/:invoice_id', ProductOrderInfo)
        ]),
        route('faq', UserCanAccessAPP(FaqBox), [
          index(LocationsShow),
          route('sections', FaqMessage),
          route('announcements', Announcements),
          route('locations/:location_id/setting', LocationSetting),
          route('sections/:section_id/edit', FaqTopicsForm),
          route('sections/:section_id/edit/:topics_id', FaqTopicsForm),
          route('application', Applications)
        ]),
        route('service', UserCanAccessEnterprise(ServiceBox), [
          index(ServiceIndex),
          route('provider/:provider_id', ServiceProvider, [
            route('info', ProviderRequest),
            route('detail', ProviderDetail)
          ]),
          route('request', ServiceRequest),
          route('request_detail/:request_id', ServiceRequestDetail)
        ]),
        route('members/:member_id', LocationMemberInfo, [
          index(MembersMessage),
          route('lock_permissions', MembersLockPermission),
          route('locks', MembersLocksRecord),
          route('meeting', MembersMeetRecord),
          route('member_orders', OrdersPersonal),
          route('member_orders/:invoice_id', OrdersInfo),
          route('point', MembersPoint),
          route('elevator', MembersElevator)
        ]),
        route('organizations/:org_id', OrgDetailBox, [
          index(OrgDetail),
          route('members', OrgMembers)
        ]),
        route('memberships', UserCanAccessMemberships(MembershipsBox), [
          index(MembershipsHome),
          route('memberManage', MembershipsManage, [
            route('members', MembershipsMembers),
            route('members/:member_id', LocationMemberInfo, [
              index(MembersMessage),
              route('lock_permissions', MembersLockPermission),
              route('locks', MembersLocksRecord),
              route('meeting', MembersMeetRecord),
              route('member_orders', OrdersPersonal),
              route('member_orders/:invoice_id', OrdersInfo),
              route('point', MembersPoint),
              route('elevator', MembersElevator)
            ]),
            route('non_members', MembershipsNonMembers),
            route('cards', MembershipsCards),
            route('cards/setting', SpaceAddMemberShip),
            route('resources', MembershipsResources),
            route('resources/setting', SpaceAddMemberShipSource),
            route('announcements', Announcements),
            route('messages', MessagesManage),
            route('pointsRecord', MembershipsPointsRecord),
            route('activities', ActivitiesList),
            route('activities/edit', ActivitiesCreateForm),
            route('activities/:activity_id', ActivitiesContainer, [
              route('info', ActivitiesInfo),
              route('orders', ActivitiesOrders),
              route('comments', ActivitiesComments)
            ]),
            route('memberWelfare', MemberWelfareList),
            route('memberWelfare/edit', MemberWelfareInfo),
            route('news', NewsList),
            route('news/edit', NewsEditForm),
            route('news/:news_id/detail', NewsDetail),
            route('posts', PostList),
            route('posts/:post_id', PostDetail)
          ])
        ]),
        route('spaces_setting', UserIsAdmin(SpacesSettingBox), [
          index(SpacesSettingBase),
          route('crm', SpacesSettingCrm),
          route('security', SpacesSettingSafe),
          route('invoice', SpaceSettingInvoice),
          route('pay', SpaceSettingPay, [index(SpacePayFlow)]),
          route('templete', SpaceTempleteBox, [
            index(SpaceTempleteList),
            route('edit', SpaceTempleteEdit)
          ]),
          route('templete_email', SpaceEmailTemplete),
          route('meeting', SpaceSettingMeeting),
          route('lock', SpaceSettingLock),
          route('currency', SpaceSettingCurrency),
          route('logs', SpaceLogs),
          route('options', SpaceSettingOptions),
          route('service', SpaceSettingService),
          route('location_groups', SpacesSettingLocationGroups)
        ]),
        route('autoAuth', SpaceAutoAuth, [index(AuthList)]),
        route('coupon', CouponBox, [
          index(CouponList),
          route('couponForm', CouponForm),
          route(':couponId', CouponContainer, [
            route('info', CouponInfo),
            route('orders', CouponOrders)
          ])
        ]),
        route('crm', UserCanAccessCRM(CrmBox), [
          index(CrmIndex),
          route('opportunities', CrmOpportunityList),
          route('opportunities/new', CrmNewOpportunityForm),
          route('opportunities/:opp_id', CrmOpportunity),
          route('opportunities/sub', EmptyLayout, [
            route('organizations/:organization_id/subscriptions/new', NewOrgSubscription),
            route('organizations/:organization_id/subscriptions/:subscription_id', SubscriptionDetailBox, subscriptionDetailRoutes)
          ]),
          route('winsubscription/:invoice_id/organizations/:organization_id/subscriptions/:subscription_id', SubscriptionDetailBox, subscriptionDetailRoutes),
          route('winsubscription', CrmWinSubscriptions),
          route('leads', CrmLeads),
          route('inventory', CrmInventory),
          route('inventory_timeline', AreasTimeLine)
        ]),
        route('guide', UserIsAdmin(GuidePage)),
        route('locations/:id', UserCanAccessLocation(LocationBox), [
          index(LocationHomePage),
          route('coupon', CouponBox, [
            index(CouponList),
            route('couponForm', CouponForm),
            route(':couponId', CouponContainer, [route('info', CouponInfo), route('orders', CouponOrders)])
          ]),
          route('visit', VisitBox, [
            index(Visit),
            route('invite', Visit),
            route('devices', VisitDeviceManage),
            route('devices/add', VisitDeviceAdd),
            route('settings', VisitSettingsBox, [
              index(VisitWelcomeSet),
              route('sign_in', VisitSignInSet),
              route('visitor_type_edit', VisitTypeEditForm),
              route('notify', VisitNotifySet),
              route('sign_out', VisitSignOutSet),
              route('sign_procedure', VisitSignProcedure),
              route('automatic_check', VisitAutomaticCheck)
            ]),
            route('black_list', VisitBlackList)
          ]),
          route('location_areas_usage', LocationAreasUsage),
          route('location_areas', LocationAreas),
          route('organizations', Organizations),
          route('new_organization', CreateOrganization),
          route('organizations/:organization_id/subscriptions/new', NewOrgSubscription),
          route('organizations/:organization_id/subscriptions/:subscription_id', SubscriptionDetailBox, subscriptionDetailRoutes),
          route('edit_organization', EditOrganization),
          route('organizations/:organization_id', Organization, [
            index(OrgSummarize),
            route('members', OrganizationMembers),
            route('contracts', OrgSubscriptions),
            route('payments', OrgAccounting),
            route('orders', OrdersOrg),
            route('point', OrganizationPoint),
            route('meeting', OrganizationMeeting),
            route('annex', OrganizationAnnex)
          ]),
          route('members', LocationMembers),
          route('locks', UserCanAccessLocation(LockBox), [
            index(LockEvents),
            route('lock_info', UserCanAccessLocation(LockManageBox), [
              route('lock_list', LockIndex),
              route('lock_list/:lock_id', LockInfo),
              route('lock_group', LockGroups),
              route('lock_group/:group_id', LockGroupDetail)
            ]),
            route('lock_permission', LockPermissions),
            route('lock_dashboard', LockDashboard),
            route('entry_record', LockEntryRecord),
            route('inactive_users', LockInactiveUsers)
          ]),
          route('areas', AreaBox, [
            route('desks', AreasBox, [
              index(AreaFloorPlan),
              route('area', AreasContainer),
              route('list', AreasList),
              route('time_line', AreasTimeLine)
            ]),
            route('desk_reservation', DeskReservationList),
            route('areacoupon', MeetingCoupon)
          ]),
          route('parking', ParkingBox, [
            route('manage', ParkingManageBox, [index(ParkingList), route('time_line', ParkingTimeLine)]),
            route('contract', ParkingContracts),
            route('contract/:subscription_id', SubscriptionDetailBox, subscriptionDetailRoutes),
            route('contract_new', ParkingContractCreate),
            route('reserve', ParkingReservation)
          ]),
          route('meetingCoupon/detail', CouponDetail),
          route('meeting', MeetingBox, [
            index(MeetingIndex),
            route('record', MeetingRecord),
            route('manage', MeetingManage),
            route('booking', MeetingAddBooking),
            route('info/:meeting_id', MeetingInfo),
            route('theme', MeetingTheme),
            route('theme/add', VisitDeviceAdd),
            route('theme/:device_id', MeetingDeviceDetail),
            route('coupon', MeetingCoupon)
          ]),
          route('tasks', TasksBox, [
            route('repair', TaskBox, [index(TasksList), route('type/my', TasksListMe), route('type/all', TasksListAll), route('type/following', TasksListFollowing), route('type/reports', TasksListReports), route(':task_id', TaskInfo)]),
            route('custom_service', TasksList),
            route('custom_service/:task_id', TaskInfo),
            route('feedback', TasksList),
            route('feedback/:task_id', TaskInfo)
          ]),
          route('invoices', UserCanAccessLocationFinance(InvoiceBox), [
            index(InvoicesContract),
            route('invoices_list', Invoices),
            route('invoices_list/:invoice_id', InvoicesInfo),
            route('invoices_list/:invoice_id/email', InvoiceSendEmail),
            route('invoices_application', InvoicesApplicationList),
            route('invoicing_pool', InvoicingPoolList),
            route('invoice_payments', InvoicePayments),
            route('location_orders', OrdersPersonal),
            route('location_orders/:invoice_id', OrdersInfo),
            route('monthly_invoices', StatisticInvoiceMonthly),
            route('confirmed_invoices', StatisticsInvoiceConfirmed),
            route('deposit', DepositList)
          ]),
          route('activities', UserCanAccessLocation(ActivityBox), [
            index(ActivitiesList),
            route('edit', ActivitiesCreateForm),
            route(':activity_id', ActivitiesContainer, [
              route('info', ActivitiesInfo),
              route('orders', ActivitiesOrders),
              route('comments', ActivitiesComments)
            ])
          ]),
          route('replacement', UserCanAccessLocation(ReplacementBox), [
            index(ReplacementList),
            route('edit', ReplacementCreateForm),
            route(':activity_id', ReplacementContainer, [
              route('info', ReplacementInfo),
              route('orders', ReplacementOrders)
            ])
          ]),
          route('autoAuth', UserCanAccessLocation(SpaceAutoAuth), [index(AuthList)]),
          route('news', UserCanAccessLocation(NewsBox), [index(NewsList), route('edit', NewsEditForm), route(':news_id/detail', NewsDetail)]),
          route('lockers', LockersBox, [index(Lockers), route('record', LockerRecord), route('categories', LockerCategories), route('cleanup', LockerCleanUpRecord)]),
          route('light', LightBox, [index(Light)]),
          route('settings', LocationSettingBox, [
            index(LocationSetBase),
            route('role', LocationSetRole),
            route('invoice', LocationSetInvoice),
            route('invoice/edit', SpaceTempleteEdit),
            route('area', LocationSetArea),
            route('subscription', LocationSetSubscription),
            route('lock', LocationSetLock),
            route('meeting', LocationSetMeeting),
            route('guide', GuideLocation),
            route('floorinfo', FloorManage),
            route('open_func', LocationSetOpenFunc),
            route('printer', LocationSetPrinterManage),
            route('lock_permission', LocationSetLockPermission),
            route('third_equity', LocationSetLockPermission)
          ]),
          route('app', UserCanAccessLocation(AppBox), [index(Applications)])
        ]),
        route('report', SpaceReportBox, [index(ReportIndex)]),
        route('user_setting', UserSettingBox, [index(UserInfo), route('password', PassWord)])
      ])
    ]
  },
  route('*', PageNotFound)
]

export default function AppRoutes() {
  return useRoutes(appRoutes)
}
